import { GrSteps as GrStepsIcon } from 'react-icons/gr';

const STROKE_CLASS = '[&_path]:stroke-current [&_polyline]:stroke-current [&_polygon]:stroke-current [&_path]:fill-none [&_polygon]:fill-none';

/** Grommet `GrSteps`; force stroke to currentColor so toolbar active/inactive colors work. */
export function GrSteps({
  size = 16,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return <GrStepsIcon size={size} className={`${STROKE_CLASS} ${className}`.trim()} />;
}
